import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { MergeRoute } from './merge.route';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    UIRouterModule.forChild({
      states: [MergeRoute]
    })
  ]
})
export class MergeModule { }
